import variables from '../variables';
/* eslint-disable */
const MuiAppBar = {
  colorDefault: {
    backgroundColor: variables.colors.backgroundDark,
  },
  colorTransparent: {
    borderBottom: `1px solid ${variables.colors.coral}`,
    width: 'auto',
    display: 'inline-flex',
  },
};

export default MuiAppBar;
